<template>
    <div class="o-bk-banner box-sh is-rounded bg-white my-2">
        <div class="o-bk-banner__inner bg-red-l2 is-rounded d-sm-flex align-items-center p-2 p-sm-0">

            <div class="p-4">
                <strong class="cl-red">
                    {{message}}
                </strong>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        message: String,
    }
}
</script>